//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      username: process.env.USERNAME,
      password: process.env.PASSWORD,
      error: false
    }
  },
  async asyncData({ $storyblok, params }) {
    const page = await $storyblok.getPage('pages/signin')
    return {
      page: page
    }
  },
  head() {
    return this.$metadata(this.page)
  },
  computed: {
    user() {
      return this.$store.state.activeUser
    },
  },
  mounted() {
    if (this.user) {
      this.$router.push('/account')
    }
  },
  methods: {
    async signin() {
      this.$store.commit('setLoading', true)
      try {
        this.error = false
        let userData = await this.$api.memberSignin(this.username, this.password)
        if(userData) {
          this.$store.commit('setUserToken', userData.tokens)
          let user = await this.$api.getMemberProfile()
          this.$store.commit('setActiveUser', user)
          if(this.$store.state.redirect) {
            let redirect = this.$store.state.redirect
            this.$store.commit('setRedirect', null)
            this.$router.push(redirect)
          } else {
            this.$router.push('/account')
          }
        } else {
          this.error = true
          // this.$store.commit('setActiveErrors', ['Please make sure your information was entered correctly.'])
        }
      } catch(err) {
        this.$store.commit('setActiveErrors', ['We’re having trouble connecting. Please try again later.'])
      }
      this.$store.commit('setLoading', false)
    }
  }
}
